export default __webpack_public_path__ + "static/media/PR.86f52f9a.svg";